import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loader',
    template: `
    <div class="loading-container" [style.position]="positionUnset ? 'unset' : 'relative'" [style.height]="positionUnset ? '100%' : 'unset'">
      @if (isLoading == true) {
        <div class="loading-indicator">
          <div class="loading-indicator__centerer">
            <img class="img" src="../../assets/images/Perifor-with-Well-Circle.png" />
            <p-progressSpinner class="spinner" strokeWidth="4"></p-progressSpinner>
          </div>
        </div>
      }
      <ng-content></ng-content>
    </div>
  `,
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent {
  @Input()
  isLoading = false;

  @Input()
  positionUnset? : boolean = false;
  
}
